import { createErrorClass } from './createErrorClass';
export const ArgumentOutOfRangeError = createErrorClass(_super => function ArgumentOutOfRangeErrorImpl() {
  _super(this);
  this.name = 'ArgumentOutOfRangeError';
  this.message = 'argument out of range';
});
